import { Injectable } from '@angular/core';
import { PromptComponent } from './prompt.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Platform } from '@angular/cdk/platform';
import { timer } from 'rxjs/internal/observable/timer';
import { take } from 'rxjs/internal/operators/take';

@Injectable({
    providedIn: 'root'
})
export class PromptService {

    constructor(
        private bottomSheet: MatBottomSheet,
        private platform: Platform
    ) { }

    initPwaInstallPrompt() {
        //// Moved to app.component because beforeinstallprompt event is not working from here
        // if (this.platform.ANDROID) {
        //     window.addEventListener('beforeinstallprompt', (event: any) => {
        //         event.preventDefault();
        //         this.openPromptComponent('android', event);
        //     });
        // }
        if (this.platform.IOS) {
            const isInStandaloneMode = ('standalone' in window.navigator) && (window.navigator['standalone']);
            if (!isInStandaloneMode) {
                this.openPromptComponent('ios');
            }
        }
    }

    openPromptComponent(mobileType: 'ios' | 'android', promptEvent?: any) {
        timer(1500)
            .pipe(take(1))
            .subscribe(() => {
                this.bottomSheet.open(PromptComponent, { data: { mobileType, promptEvent: promptEvent } });
            });
    }
}
